import { useEffect } from "react";

import { ConsultantProfile } from "@/data/consultant-profiles/types/ConsultantProfile";
import { JobApplication } from "@/data/job-applications/types/JobApplication";

import { TransformDraftFunction, useApplyWizard } from "./ApplyWizardContext";

export const useApplyWizardDraftUpdate = (transformDraft: TransformDraftFunction) => {
  const { jobRequest, profile, draft, setDraft } = useApplyWizard();

  return useEffect(() => {
    const newDraft = transformDraft(
      draft ??
        ({
          consultantProfile: {
            ...profile,
            cvs: [],
          } as ConsultantProfile,
          rate: {
            currency: jobRequest.rate.currency,
          },
        } as JobApplication),
    );

    if (JSON.stringify(newDraft) !== JSON.stringify(draft)) {
      setDraft(draft =>
        transformDraft(
          draft ??
            ({
              consultantProfile: {
                ...profile,
                cvs: [],
              } as ConsultantProfile,
              rate: {
                currency: jobRequest.rate.currency,
              },
            } as JobApplication),
        ),
      );
    }
  }, [jobRequest, profile, transformDraft, draft, setDraft]);
};
